import React, { useContext, useState, useEffect } from 'react'
import { Link, NavLink } from 'react-router-dom'
import AuthContext from '../../context/AuthContext'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
 
import Dashboard from '../../assets/images/sidebar_icon1.svg'
import leavesManager from '../../assets/icons/Leaves-manager.svg'
import manageJobs from '../../assets/icons/manage-jobs.svg'
import biometricManager from '../../assets/icons/biometric-module.svg'
import submittedForms from '../../assets/icons/employee-task-schedule.svg'
import acceptedEmployee from '../../assets/icons/accepted-employee.svg'
import offerLetter from '../../assets/icons/Hr-onboarding.svg'
import employeeTask from '../../assets/icons/employee-task-schedule.svg'
import Logout from '../../assets/images/logout.svg'
import FormsManager from '../../assets/images/hr_forms-manager.svg'
import SuggestedForms from '../../assets/images/forms_manager.svg'
import InterviewScheduling from '../../assets/images/calendar_camera_icon_outline.svg'
import BackgroundVerification from '../../assets/images/employee-request.svg'
import mailManager from '../../assets/images/notification_manager.svg'
import StaticContent from '../../assets/images/static_contents.png'
import scheduleManager from '../../assets/icons/clipboard-clock.svg'
import timesheetManager from '../../assets/icons/timesheet.svg'
import hand_coins from '../../assets/icons/hand-coins.svg'
import aiRecruitementAssistant from '../../assets/icons/ai-recruitment-assistant.svg'

import { useTranslation } from 'react-i18next'
 
import {
  FaChevronDown,
  FaChevronRight,
  FaUserPlus,
  FaUsers,
  FaUserTie,
  FaCogs,
  FaBullhorn
} from 'react-icons/fa'
 
import { MdFactCheck } from 'react-icons/md'
import { PiCertificate } from 'react-icons/pi'
 
const classNames = require('classnames')
 
const HRSidebar = () => {
  const { t } = useTranslation()
 
  const {
    logoutUser,
    updatePageName,
    user,
    sidebarStatus
  } = useContext(AuthContext)
 
  const [openMenus, setOpenMenus] = useState({})
  
  // ─── NEW STATE FOR PAYROLL STATUS ───
  const [isPayrollActive, setIsPayrollActive] = useState(false)

  // ─── CHECK PAYROLL STATUS ON MOUNT ───
  useEffect(() => {
    const checkPayrollStatus = async () => {
      try {
        const res = await apiGet(apiPath.payrollStatus)
        // Check if it's active AND verified
        if (res?.data?.success && res.data.results?.isActive && res.data.results?.verifiedAt) {
          setIsPayrollActive(true)
        }
      } catch (error) {
        // Silently fail and keep it hidden if there's an error checking
        console.error("Failed to check payroll status in sidebar", error)
      }
    }
    
    // Only check if user is logged in
    if (user) {
      checkPayrollStatus()
    }
  }, [user])

  const toggleMenu = (menuKey) => {
    setOpenMenus(prev => ({
      ...prev,
      [menuKey]: !prev[menuKey]
    }))
  }
 
  const getNavLinkClassName = (isActive) =>
    classNames(
      'text-white active:text-LightBlue flex items-center px-4 lg:px-7 py-3 hover:bg-white hover:text-LightBlue transition-colors duration-200',
      { active: isActive }
    )
 
  const handleLogout = () => {
    if (window.confirm('Are you sure to logout?')) {
      logoutUser()
    }
  }
 
  // ---------------------------------------------------------
  // MENU CONFIGURATION
  // ---------------------------------------------------------
 
  const menuConfig = [
    {
      key: 'hire',
      label: 'Hire',
      icon: <FaUserPlus className="text-lg" />,
 
      items: [
                { label: t('NAV_EMPLOYEE_RECOMMENDATION'), path: '/employee-recomendation', icon: aiRecruitementAssistant },
        {
          label: t('NAV_EMPLOYEE_REQUEST'),
          path: '/employee-request',
          icon: acceptedEmployee
        },
        {
          label: t('NAV_INTERVIEW_MANAGER'),
          path: '/interview-manager',
          icon: InterviewScheduling
        },
        {
          label: t('NAV_BACKGROUND_CHECK'),
          path: '/background-verification',
          icon: BackgroundVerification
        },
        {
          label: t('NAV_SUBMITTED_FORMS_BY_EMPLOYEE'),
          path: '/submittedFormsByEmployee',
          icon: submittedForms
        }
      ]
    },
 
    {
      key: 'people',
      label: 'People',
      icon: <FaUsers className="text-lg" />,
 
      items: [
        {
          label: t('NAV_ALL_EMPLOYEE_LIST'),
          path: '/all-employee-list',
          icon: acceptedEmployee
        },
        {
          label: t('NAV_TIMESHEET_MANAGER'),
          path: '/timesheet-manager',
          icon: timesheetManager
        },
        {
          label: t('Attendance Report'),
          path: '/attendance-report',
          icon: biometricManager
        },
        // ─── CONDITIONALLY ADD Payroll ───
        ...(isPayrollActive ? [{
          label: t('Payroll'),
          path: '/payroll-wages',
          icon: hand_coins
        }] : [])
      ]
    },
 
    {
      key: 'hr',
      label: 'HR',
      icon: <FaUserTie className="text-lg" />,
 
      items: [
        {
          label: t('NAV_FORMS_MANAGER'),
          path: '/forms-manager',
          icon: FormsManager
        },
        {
          label: t('NAV_SUGGESTED_FORMS'),
          path: '/suggested-forms',
          icon: SuggestedForms
        },
        {
          label: t('NAV_DOCUMENT_MANAGER'),
          path: '/document-manager',
          icon: StaticContent
        },
        {
          label: t('LEAVES_MANAGER'),
          path: '/leave-manager',
          icon: leavesManager
        },
 
        // React Icon
        {
          label: t('TRAINING_CERTIFICATION'),
          path: '/training-certification',
          icon: <PiCertificate className="text-lg" />
        },
 
        // Existing image icon
        {
          label: t('OFFER_LETTER_LIST'),
          path: '/offer-letter',
          icon: offerLetter
        }
      ]
    },
 
    {
      key: 'operations',
      label: 'Operations',
      icon: <FaCogs className="text-lg" />,
 
      items: [
        {
          label: t('NAV_SCHEDULE_MANAGER'),
          path: '/schedule-manager',
          icon: scheduleManager
        },
        {
          label: t('GEO_AREA_LOCATIONS'),
          path: '/geo-area-locations',
          icon: scheduleManager
        },
        {
          label: t('MANAGE_JOBS'),
          path: '/manage-jobs',
          icon: manageJobs
        },
        {
          label: t('EMPLOYEE_TASKS_SCHEDULING'),
          path: '/employee-tasks-scheduling',
          icon: employeeTask
        },
        {
          label: t('REPORTS'),
          path: '/reports',
          icon: StaticContent
        }
      ]
    },
 
    {
      key: 'communications',
      label: 'Communications',
      icon: <FaBullhorn className="text-lg" />,
 
      items: [
        {
          label: t('MAIL_MANAGER'),
          path: '/mail-manager',
          icon: mailManager
        }
      ]
    }
  ]
 
  return (
    <>
      <div
        className={`sidebar z-10 lg:block ${sidebarStatus === 'close'
          ? 'hideSideBar'
          : 'block'
          } bg-gradient-to-t from-gradpurple xl:w-[280px] fixed to-gradblue w-[220px] h-full overflow-y-auto`}
      >
        <div className="text-white">
 
          {/* LOGO */}
          <Link onClick={() => updatePageName('Dashboard')} to="/dashboard"
            className="px-2 py-6 flex justify-center w-full text-center">
            <img className="inline" src="./images/logo_white.png" alt="Logo"/>
          </Link>
 
          {/* PROFILE */}
          <div className="text-center profile pb-4">
            <small className="block text-sm">
              Welcome HR
            </small>
 
            <strong className="block text-ellipsis text-lg overflow-hidden px-2 whitespace-nowrap">
              {user?.name}
            </strong>
          </div>
          <nav className="flex flex-col pb-5 justify-center font-normal text-xs overflow-y-auto">
 
            {/* DASHBOARD */}
 
            <NavLink
              to="/dashboard"
              onClick={() => updatePageName(t('NAV_DASHBOARD'))}
              className={({ isActive }) => getNavLinkClassName(isActive)}>
              <span className="mr-2">
                <img className="max-w-[18px]" src={Dashboard} alt="" />
              </span>
 
              {t('NAV_DASHBOARD')}
            </NavLink>
 
            {/* COMPLIANCE DASHBOARD */}
 
            <NavLink to="/Compilence"
              onClick={() => updatePageName(t('COMPILENCE_DASHBOARD'))}
              className={({ isActive }) => getNavLinkClassName(isActive)}>
              <span className="mr-2 text-lg flex items-center"><MdFactCheck /></span>
              {t('COMPILENCE_DASHBOARD')}
            </NavLink>
 
            {menuConfig.map((category, i) => (
              <div key={category.key} className={`${i === 0 ? 'border-t' : ''} border-b border-white/10 last:border-0`}>
 
                <button onClick={() => toggleMenu(category.key)} className="w-full text-left px-4 lg:px-7 py-4 text-white flex items-center justify-between hover:bg-white/10 transition-colors duration-200 focus:outline-none">
                  <div className="flex items-center gap-3">
                    <span className="flex items-center justify-center w-5 h-5">{category.icon}</span>
                    <span className="font-medium tracking-wide uppercase text-xs">{category.label}</span>
                  </div>
                  <span className="text-xs">
                    {openMenus[category.key] ? <FaChevronDown /> : <FaChevronRight />}
                  </span>
                </button>
                {openMenus[category.key] && (
                  <div className="flex flex-col bg-black/10 pb-2">
                    {category.items.map((item, index) => (
                      <NavLink key={index} to={item.path} onClick={() => updatePageName(item.label)} className={({ isActive }) => getNavLinkClassName(isActive)}>
                        <span className="mr-2 ml-6 flex items-center">
                          {typeof item.icon === 'string' ? (<img className="max-w-[18px]" src={item.icon} alt="" />) : (item.icon)}
                        </span>
                        {item.label}
                      </NavLink>
                    ))}
                  </div>
                )}
              </div>
            ))}
            <Link
              onClick={handleLogout}
              className="lg:px-7 py-4 text-white flex items-center px-4 active:text-LightBlue hover:bg-white hover:text-LightBlue"
            >
 
              <span className="mr-2">
 
                <img
                  className="max-w-[18px]"
                  src={Logout}
                  alt="logout"
                />
 
              </span>
 
              {t('NAV_LOGOUT')}
 
            </Link>
 
          </nav>
        </div>
      </div>
    </>
  )
}
 
export default HRSidebar